// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3kaij","alert":"SettungsInbox_alert__3uM36"};